
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"20","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M15.143 13.244L15.98 11l2.698 5.641L13 19.143l.805-2.23S5.75 13.375 6.097 6c2.715 5.938 9.046 7.244 9.046 7.244zM24 6v18H6v-6H0V0h18v6h6zm-2 2H9.888a10.316 10.316 0 01-1.521-2H16V2H2v14h4v-3.124c.6.961 1.287 1.823 2 2.576V22h14V8z"}})])
          )
        }
      }
    